import { useEffect, useRef } from 'react';
import { getWorkflowLogOutput } from '@/redux/actions/gravityActions';
import pollWorkflowLogFinalization from './pollWorkflowLogFinalization';

const useWorkflowLogFinalization = ({ workflowId, workflowLogId, log }) => {
  const isPending = log?.statusId === 0 || log?.statusId === 1 || log?.meta?.logUploadStatus === 'uploading';
  const pendingOutputLogRef = useRef(null);

  useEffect(() => {
    if (!workflowId || !workflowLogId || workflowLogId === 'summary') {
      pendingOutputLogRef.current = null;
      return;
    }
    const logKey = `${workflowId}-${workflowLogId}`;
    if (isPending) {
      pendingOutputLogRef.current = logKey;
      return pollWorkflowLogFinalization({ workflowId, workflowLogId });
    }
    if (pendingOutputLogRef.current === logKey && log?.finishedOn) {
      getWorkflowLogOutput({ workflowId, logId: workflowLogId });
    }
    pendingOutputLogRef.current = null;
  }, [workflowId, workflowLogId, isPending, log?.finishedOn]);
};

export default useWorkflowLogFinalization;
